import React from 'react';
import { PageConfig } from '../../types';
import { SuperSection } from '../structure';
import { FloatingWhatsApp } from '../../components';

interface LayoutDefaultProps {
  page: PageConfig;
}

export function LayoutDefault({ page }: LayoutDefaultProps) {
  return (
    <div className="layout layout--default">
      <SuperSection sections={page.sections} />
      <FloatingWhatsApp />
    </div>
  );
}
